import React, { Component } from 'react'

export default class EmptyComp extends Component {
    constructor(props) {
        super(props)
    }

    //handler
    mouseLeave = (e) => { }
    mouseEnter = (e) => { }

    render() {

        const style = {
            position: "relative",
            width: "100%",
            height: "100%"
        }

        const comp = (this.props.comp) ? this.props.comp : <div></div>
        return (
            <div style={style} name={"EmptyComp"} id={this.props.id}>
                {comp}
            </div >
        )
    }
}
